import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import starZoneApi from '@/api/starZoneApi'

let cacheToken = ''
let cacheData: any = null
let pendingRequest: Promise<any> | null = null

const permission = ref<any>(cacheData)
const isReady = ref(!!cacheData)

async function fetchPermission(token: string, force = false): Promise<any> {
  if (!token) {
    isReady.value = true
    return null
  }

  if (!force && cacheToken === token && cacheData != null) {
    permission.value = cacheData
    isReady.value = true
    return cacheData
  }

  if (!force && cacheToken === token && pendingRequest) {
    return pendingRequest
  }

  cacheToken = token
  pendingRequest = starZoneApi
    .getUserPermission({ headers: { token } })
    .then((res) => {
      if (res?.code === 1 || res?.code === 0) {
        cacheData = res.data || null
        permission.value = cacheData
      }
      return cacheData
    })
    .catch((e) => {
      console.error('getUserPermission failed', e)
      return cacheData
    })
    .finally(() => {
      isReady.value = true
      pendingRequest = null
    })

  return pendingRequest
}

export function useStarUserPermission() {
  const route = useRoute()

  const loadPermission = (force = false) => {
    const token = (route.query.token as string) || ''
    if (!token) {
      isReady.value = true
      return Promise.resolve(null)
    }
    return fetchPermission(token, force)
  }

  watch(
    () => route.query.token as string,
    (token) => {
      if (!token) {
        isReady.value = true
        return
      }
      if (token !== cacheToken || cacheData == null) {
        void fetchPermission(token)
      } else {
        permission.value = cacheData
        isReady.value = true
      }
    }
  )

  void loadPermission()

  return {
    permission,
    isReady,
    loadPermission,
    refreshPermission: () => loadPermission(true),
  }
}
